/**
 * @file test-case-version.form.tsx
 * @description Форма для создания и редактирования версий тестовых случаев в системе тестирования.
 * Включает поля для указания релизов поддержки (начало и окончание) и конфигурационных файлов (In, Out, Log).
 * Позволяет настраивать версионность тестов и связывать их с конкретными релизами системы.
 * Интегрируется с react-hook-form через control prop.
 * @author AI Assistant
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [react, @components/form-controls/dictionary, @consta/uikit/Text]
 * @related-files [@components/form-controls/dictionary/dictionary.component.tsx]
 */

import { Dictionary } from '@components/form-controls/dictionary';
import { Text } from '@consta/uikit/Text';

export const TestCaseVersionForm = ({ control }: any) => {
    return (
        <div className="flex flex-col gap-[1.0585vmin]">
            <div className="flex flex-col gap-[0.4234vmin]">
                <Text size="s" className="whitespace-nowrap dictionary__label font-medium leading-[2.5405vmin]">
                    Поддержка
                </Text>

                <div className="flex gap-default">
                    <Dictionary label="Релиз начала" name="releaseSupportStart" control={control} />

                    <Dictionary label="Релиз окончания" name="releaseSupportEnd" control={control} />
                </div>
            </div>

            <Text size="s" className="whitespace-nowrap dictionary__label font-medium leading-[2.5405vmin]">
                Конфигурации
            </Text>

            <Dictionary label="In" name="configIn" control={control} />

            <Dictionary label="Out" name="configOut" control={control} />

            <Dictionary label="Log" name="configLog" control={control} />
        </div>
    );
};
